import { useState } from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Logo } from '@/components/layout/Logo';
import { Button } from '@/components/ui/Button';
import { publicNavLinks } from '@/app/public/navigation';

export function PublicLayout() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="min-h-full flex flex-col">
      <header className="h-14 flex items-center justify-between px-4 md:px-8 border-b border-border-subtle sticky top-0 bg-bg-base/95 backdrop-blur-0 z-20">
        <Link to="/" className="flex items-center" aria-label="Dem home">
          <Logo />
        </Link>

        <nav className="hidden md:flex items-center gap-6" aria-label="Main navigation">
          {publicNavLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) =>
                [
                  'text-body-medium',
                  isActive ? 'text-text-primary' : 'text-text-secondary hover:text-text-primary',
                ].join(' ')
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:block">
          <Link to="/dashboard">
            <Button variant="primary" size="md">
              Dashboard
            </Button>
          </Link>
        </div>

        <button
          type="button"
          className="md:hidden h-11 w-11 flex items-center justify-center text-text-secondary"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
        >
          {menuOpen ? <X size={22} aria-hidden="true" /> : <Menu size={22} aria-hidden="true" />}
        </button>
      </header>

      {menuOpen ? (
        <div className="md:hidden fixed inset-0 top-14 z-10 bg-bg-base p-4 flex flex-col gap-1">
          {publicNavLinks.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              onClick={() => setMenuOpen(false)}
              className="px-3 py-3 min-h-[44px] rounded-sm text-body-medium text-text-primary hover:bg-bg-elevated"
            >
              {link.label}
            </NavLink>
          ))}
          <Link to="/dashboard" onClick={() => setMenuOpen(false)} className="mt-2">
            <Button variant="primary" size="lg" className="w-full">
              Dashboard
            </Button>
          </Link>
        </div>
      ) : null}

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="border-t border-border-subtle px-4 md:px-8 py-8 mt-16">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <Logo />
          <p className="text-small text-text-tertiary">
            Dem Web is an independent dashboard for the Dem Discord bot.
          </p>
        </div>
      </footer>
    </div>
  );
}
